<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Menu</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="request()">
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.code"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã code"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.name"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="request(data.item, data.item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import FormRequest from './_form-request.vue'
  import { MdService } from '@/services/md.service'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã', thStyle: 'min-width: 100px' },
    { key: 'name', label: 'Tên', thStyle: 'min-width: 100px' },
    { key: 'url', label: 'Đường dẫn', thStyle: 'min-width: 100px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'MENU',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      edit(id) {
        const routeData = this.$router.resolve({ path: `/ticket/${id}` })
        window.open(routeData.href, '_blank')
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.fetchData()
      },
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await MdService.fetch(params)
          if (response.code === 1000) {
            this.lists = response.data.data
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
          this.selectedTicket = []
        }
      },
      request(items = null, id = null) {
        this.showModalComponentMx(id ? 'Cập nhật' : 'Thêm mới', {
          name: FormRequest,
          props: {
            items,
            id,
          },
          id: 'MenuRequest',
          footerClass: 'd-none',
        }).then(_ => this.fetchData())
      },
    },
  }
</script>
